const src = import.meta.ROLLUP_FILE_URL_4L8X5Y0W5Xr4aSsV2zlAig;
export default {
  src,
  srcSet: src + " " + 2247 + "w",
  width: 2247,
  height: 1053,
};